<template>
  <div class="row-separator blocSimpleAnalysis">
    <v-data-table
      :headers="tableHeaders"
      :items="items"
      :disableSort="true"
      :itemsPerPage.sync="items.length"
      :hideDefaultFooter="true"
      class="blocSimpleAnalysis"
    />
  </div>
</template>
<script>
export default {
    props: {
        items: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            data: {},
        };
    },
    computed: {
        tableHeaders() {
            return [
                'analysisName',
                'ERPCode',
            ].map(header => ({
                text: header.length ? this.$t(`forms.labels.${header}`) : '',
                value: header,
            }));
        },
    },
};
</script>
<style lang="scss" scoped>
.history {
    border: 1px solid #BDC2D0;
    margin: 0 6rem;
}

</style>
<style lang="scss">
  .blocSimpleAnalysis col:first-of-type{
    width: 50%;
  }
</style>

<style lang="scss">
  .blocSimpleAnalysis {
    tbody {
      .v-data-table__mobile-row:nth-child(2) {
        border-bottom: 1px solid #BDC2D0 !important;
      }
    }
  }
</style>
